import { useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { useDispatch } from 'react-redux'
import { setLocalStorageItem } from '../../utils/local-storage.ts'
import {
  requestUserInfo,
  setAccessToken,
} from '../../features/user/user.slice.ts'
import {
  NEW_RELIC,
  NEW_RELIC_AUTH_EVENT,
  newRelic,
} from '@/utils/new-relic.ts'

export const Auth0RefreshBridge = () => {
  const { getAccessTokenSilently, loginWithRedirect } = useAuth0()
  const dispatch = useDispatch()

  useEffect(() => {
    const handler = async () => {
      newRelic.recordCustomEvent(NEW_RELIC_AUTH_EVENT.silentRefreshRequested, {
        element: NEW_RELIC.AUTH.silentRefresh,
      })
      try {
        const auth0Token = await getAccessTokenSilently()

        newRelic.recordCustomEvent(
          NEW_RELIC_AUTH_EVENT.silentRefreshSucceeded,
          { element: NEW_RELIC.AUTH.silentRefresh }
        )
        setLocalStorageItem('accessToken', auth0Token)
        dispatch(setAccessToken(auth0Token))
        dispatch(requestUserInfo())
      } catch (error) {
        newRelic.recordCustomEvent(NEW_RELIC_AUTH_EVENT.silentRefreshFailed, {
          element: NEW_RELIC.ERROR.auth0,
          event: `${error}`,
        })
        // noticeError routes this through the error pipeline, which is what
        // links a Session Replay recording to the failure. recordCustomEvent
        // alone gives no replay to jump to.
        newRelic.noticeError(error as Error, {
          context: 'silentAuth0Refresh',
        })
        console.error('Silent Auth0 refresh failed', error)
        loginWithRedirect()
      }
    }

    window.addEventListener('auth0-silent-refresh', handler)

    return () => {
      window.removeEventListener('auth0-silent-refresh', handler)
    }
  }, [dispatch, getAccessTokenSilently, loginWithRedirect])

  return null
}
